import { FC, ReactNode, Suspense } from "react";

import ScannerDocumentConfig from "models/scanner-document-config";
import { ScannerType } from "models/scanner-type";

import { capturerRegistry } from "./Capturer-registry";
import { LowResolutionOverlayStatus, ScannerStatus } from "./DocumentCapture";
import { ScannerAnalyticsEventType } from "../shared/hooks/analytics/useScannerAnalytics";

export interface CapturerProps {
  paxSessionId: string | undefined;
  itemType: string;
  docScannerConfig: ScannerDocumentConfig;
  overlay: ReactNode;
  uploadButton: ReactNode;
  // hooks
  setResultImages: (images: ImageData[]) => void;
  scannerStatus: ScannerStatus;
  setSelectedScannerType: (scannerType: ScannerType) => void;
  setScannerStatus: (status: ScannerStatus) => void;
  moveScannerToNextState: () => void;
  lowResOverlayStatus: LowResolutionOverlayStatus;
  setLowResOverlayStatus: (
    lowResolutionOverlayStatus: LowResolutionOverlayStatus
  ) => void;
  sendScannerAnalyticsEvent: (eventType: ScannerAnalyticsEventType) => void;
  // events from parent to trigger
  onCancel: () => void;
  onUploadProcessStarted: () => void;
  // other callbacks
  cameraStream: MediaStream | undefined;
  isLowResolution: boolean;
  registerOnCancelCallback: (callback: () => void) => void;
  registerOnReScanCallback: (callback: () => void) => void;
  registerOnUploadProcessStartedCallback: (callback: () => void) => void;
}

interface CapturerWrapperProps extends CapturerProps {
  // Which scanner to render, resolved at runtime (A/B flag) by DocumentCapture.
  selectedScanner: ScannerType;
}

const Capturer: FC<CapturerWrapperProps> = ({
  selectedScanner,
  ...capturerProps
}) => {
  const ClientCapturer = capturerRegistry[selectedScanner];

  return (
    <Suspense fallback={null}>
      <ClientCapturer {...capturerProps} />
    </Suspense>
  );
};

export default Capturer;
